import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFormRow, EuiSpacer, EuiText, EuiTextArea, EuiTitle } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { setDetails } from 'features/planner/CreateMasterCampaignPlanSlice'
import useBreakpoint from 'utils/useBreakpoint'

export const AdditionalDetailsStep = () => {
  const { sm, md, lg } = useBreakpoint()
  const dispatch = useDispatch()
  const { details } = useSelector((state: RootState) => state.createMasterCampaignPlan)
  const { currentAccount } = useSelector((state: RootState) => state.app)

  const formRowProps = {
    fullWidth: sm || md,
    style: { maxWidth: lg ? '50rem' : undefined, height: '20rem' }
  }

  return (
    <div style={{ height: '100%' }}>
      <EuiTitle size={'s'}>
        <h2>Step 4: Additional Details</h2>
      </EuiTitle>
      <EuiText>
        <p>Please provide any additional insights about {currentAccount?.name} that might help AdCritter AI in creating the first draft of the master campaign plan.</p>
      </EuiText>
      <EuiSpacer />
      <EuiFormRow {...formRowProps} helpText={'Additional details might include things such as geography, target personas, or specific business information.'}>
        <EuiTextArea {...formRowProps} aria-label='Use aria labels when no actual label is in use' value={details} onChange={e => dispatch(setDetails(e.target.value))} />
      </EuiFormRow>
    </div>
  )
}
